// ** Icon Imports
import { Icon as IconifyIcon, IconProps } from '@iconify/react'

const Icon = ({ icon, ...rest }: IconProps) => {
  return <IconifyIcon icon={icon} fontSize="1.375rem" {...rest} />
}

export default Icon
